import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { Field } from 'redux-form';
import ReactTable from 'react-table';
import treeTableHOC from 'react-table/lib/hoc/treeTable';
import moment from 'moment';
import PropTypes from 'prop-types';

import { DatePickerField } from 'Common/SemanticWrapper';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { ConsolidateEnum, ItemEnum } from 'Common/FieldEnum';
import {
  ItemStatusEnum,
  ItemStatusTextEnum,
} from 'Common/Constants/Enumeration/Consolidate';
import { YesNoDialog } from 'Components/dialogs/YesNoDialog';
import { DatePickerCustomButton, NotificationDialog } from 'Components';
import { SiteComponent } from 'Common/SiteComponent';

const TreeTable = treeTableHOC(ReactTable);
const ChildTableStyle = {
  headerStyle: {
    textAlign: 'left',
    marginLeft: 5,
  },
};
const ConsolidateOrdersComponent = props => {
  const {
    onSiteAndDeliveryDateChange,
    consolidateData,
    getTdProps,
    showDialog,
    onSubmitClick,
    setExpandedState,
    expanded,
    defaultFilterMethod,
    showWHAssociationDialog,
    whAssociationMessage,
    showWHAssociationDialogOkClick,
    showNotQualified,
    showNotQualifiedOkClick,
    getYesNoDialogMsg,
    consolidateMessageHandle,
  } = props;
  const notQualifiedMessage =
    'Consolidation cancelled! You do not have any items to process';

  return (
    <Form>
      <Grid className={'remove-spacing'}>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Field
              component={DatePickerField}
              dateFormat={DATE_FORMAT_FOR_UI}
              label={'Order Date'}
              name={ConsolidateEnum.OrderDT}
              type={'text'}
              customInput={<DatePickerCustomButton isDisabled={true} />}
              dropdownMode="select"
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              component={DatePickerField}
              dateFormat={DATE_FORMAT_FOR_UI}
              label={'Delivery Date'}
              name={ConsolidateEnum.DeliveryDate}
              type={'text'}
              minDate={moment()}
              onChange={(event, newValue, previousValue, name) => {
                onSiteAndDeliveryDateChange({ [name]: newValue });
              }}
              dropdownMode="select"
              customInput={<DatePickerCustomButton />}
            />
          </Grid.Column>
          <Grid.Column>
            <SiteComponent
              name={ConsolidateEnum.SiteId}
              isForm={true}
              label={'Site'}
              isAllRequired={false}
              showAllActiveSites={true}
              onChange={(newValue, previousValue, name) =>
                newValue !== previousValue &&
                onSiteAndDeliveryDateChange({ [name]: newValue })
              }
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={1}>
          <Grid.Column>
            <TreeTable
              filterable
              data={
                consolidateData &&
                consolidateData[ConsolidateEnum.ConsolidateManagerModel]
                  ? consolidateData[ConsolidateEnum.ConsolidateManagerModel]
                  : []
              }
              pivotBy={[ItemEnum.ItemStatus]}
              getTdProps={getTdProps}
              columns={[
                {
                  id: ItemEnum.ItemStatus,
                  accessor: value => {
                    let text = '',
                      val = value[ItemEnum.ItemStatus];
                    val === ItemStatusEnum.ITEMS_QUALIFIED
                      ? (text = ItemStatusTextEnum.ITEM_TOBE_ORDERED)
                      : val === ItemStatusEnum.ITEMS_DISQUALIFIED
                      ? (text = ItemStatusTextEnum.ITEM_CANNOT_BE_ORDERED)
                      : (text = ItemStatusTextEnum.ITEM_NOT_NEEDED);
                    return text;
                  },
                  sortable: false,
                  filterable: false,
                  resizable: false,
                  width: 0,
                },
                {
                  Header: 'Item Code',
                  accessor: ItemEnum.ItemCode,
                },
                {
                  Header: 'Description',
                  accessor: ItemEnum.ItemDescription,
                },
                {
                  Header: 'Qty.Ordered',
                  accessor: ItemEnum.QtyOrdered,
                },
                {
                  Header: 'Qty.Available',
                  accessor: ItemEnum.QtyAvailable,
                },
                {
                  Header: 'Qty.Needed',
                  accessor: ItemEnum.QtyNeeded,
                },
              ]}
              defaultPageSize={5}
              defaultFilterMethod={defaultFilterMethod}
              expanded={expanded}
              onExpandedChange={expanded => setExpandedState(expanded)}
              SubComponent={rowData => {
                const row = rowData.original;
                const columns = [
                  {
                    Header: 'SiteId',
                    accessor: ConsolidateEnum.SiteId,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'SiteName',
                    accessor: ConsolidateEnum.SiteName,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'ItemCode',
                    accessor: ItemEnum.ItemCode,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Description',
                    accessor: ItemEnum.ItemDescription,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Purchase Qty',
                    accessor: ItemEnum.PrimaryQty,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Unit',
                    accessor: ItemEnum.Unit,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Pack Qty',
                    accessor: ItemEnum.SecondaryQty,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Sec.Unit',
                    accessor: ItemEnum.SecondaryUnit,
                    ...ChildTableStyle,
                  },
                  {
                    Header: 'Primary Price',
                    accessor: ItemEnum.PrimaryPrice,
                    ...ChildTableStyle,
                  },
                ];
                return (
                  <div style={{ padding: '0px 10px 10px 15px' }}>
                    <ReactTable
                      data={row[ConsolidateEnum.ItemSiteDetails]}
                      columns={columns}
                      pageSize={row[ConsolidateEnum.ItemSiteDetails].length}
                      showPagination={false}
                    />
                  </div>
                );
              }}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>

      <NotificationDialog
        showDialog={showWHAssociationDialog || showNotQualified}
        message={
          showWHAssociationDialog ? whAssociationMessage : notQualifiedMessage
        }
        title={'WH Association'}
        onOkClick={
          showWHAssociationDialog
            ? showWHAssociationDialogOkClick
            : showNotQualifiedOkClick
        }
      />
      <YesNoDialog
        showDialog={
          showDialog ||
          (!!consolidateData[ConsolidateEnum.OrderConsolidatedVerification] &&
            consolidateData[ConsolidateEnum.OrderConsolidatedVerification] > '')
        }
        title={'Consolidate Order'}
        question={
          showDialog
            ? getYesNoDialogMsg()
            : !!consolidateData[
                ConsolidateEnum.OrderConsolidatedVerification
              ] &&
              consolidateData[ConsolidateEnum.OrderConsolidatedVerification]
        }
        yesCallback={() =>
          showDialog ? onSubmitClick(true) : consolidateMessageHandle(true)
        }
        noCallback={() =>
          showDialog ? onSubmitClick(false) : consolidateMessageHandle(false)
        }
      />
    </Form>
  );
};

ConsolidateOrdersComponent.propTypes = {
  onSiteAndDeliveryDateChange: PropTypes.func,
  consolidateData: PropTypes.object,
  getTdProps: PropTypes.func,
  showDialog: PropTypes.bool,
  onSubmitClick: PropTypes.func,
  setExpandedState: PropTypes.func,
  expanded: PropTypes.object,
  defaultFilterMethod: PropTypes.func,
  showWHAssociationDialog: PropTypes.bool,
  whAssociationMessage: PropTypes.string,
  showWHAssociationDialogOkClick: PropTypes.func,
  showNotQualified: PropTypes.bool,
  showNotQualifiedOkClick: PropTypes.func,
  getYesNoDialogMsg: PropTypes.func,
  consolidateMessageHandle: PropTypes.func,
};

export default ConsolidateOrdersComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/manageprocessorder/components/consolidate/ConsolidateOrders.js